import { useState, useEffect,useContext } from "react"
import { Button } from "@mui/material";
import styles from "./Manufacture.module.css"
import { useForm, SubmitHandler } from "react-hook-form";
import { baseUrl } from "../../url";
import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType } from "../../Auth";

type Manufacturetype = {
    manufacture: string;
}

export default function Manufacture() {

    const [manufactures, setManufactures] = useState<string[]>([]);
    const { setAuth } = useContext(AuthContext) as AuthContextType;
    const navigate = useNavigate();

    useEffect(()=>{
        const checkAuth = async () => {
            try {
                    const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                })
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                   setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user"});
                   return navigate("/login");
                }
                         const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
                } catch (error) {
                console.error(error);
            }
        }
        checkAuth();
    },[navigate, setAuth])

    useEffect(() => {
        const fetchSelectInit = async () => {
            const response = await fetch(`${baseUrl}/getmanufacture`,{
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            const Manufacture = data.manufacture.map((item: Object) => Object.values(item))
            setManufactures(Manufacture);
        }
        fetchSelectInit();
    }, [manufactures, navigate, setAuth])

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm<Manufacturetype>(
        { mode: 'onBlur' }
    )

    const onSubmit: SubmitHandler<Manufacturetype> = async (data) => {
        const datastr = JSON.stringify(data);
        const response = await fetch(`${baseUrl}/createmanufacture`, {
            method: "POST",
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: datastr
        })
        const resjson = await response.json();
        if(resjson.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
        alert(resjson.message);
        reset();
    }

    const handleDelete = async (index: number) => {
        const deletename = manufactures[index];
        if (window.confirm(`メーカーを${deletename}で登録している製品もすべて削除されます。${deletename}を削除してもよろしいですか？在庫にある製品のみ残ります。`)) {
            try {
                const response = await fetch(`${baseUrl}/deletemanufacture`, {
                    method: "DELETE",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "deletemanufacture": deletename })
                })
                const data = await response.json();
                if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
                if (!response.ok) {
                    throw new Error("Network response was not OK");
                }
                alert("削除に成功しました。");
            } catch (error) {
                console.error(error);
            }
        } else {
            alert("削除をキャンセルしました。")
        }
    }

    return (
        <div className={styles.div}>
            <h2 className={styles.h2}>メーカー登録</h2>
            <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
                <input type="text" className={styles.input} {...register("manufacture",
                    {
                        required: "メーカーの名称は必須です。",
                        maxLength: {
                            value: 50, message: "50文字以内で入力してください。"
                        },
                        pattern: { value: /^[Ａ-Ｚ\u4E00-\u9FFFぁ-んァ-ヶ０-９ー・　]+$/, message: "全角で入力してください。" },
                    })} />
                <span className={styles.span}>{errors.manufacture?.message}</span>
                <Button type="submit" variant="contained" style={{ fontSize: 16, margin: 15 }} >登録</Button>
            </form>
            <table className={styles.table}>
                <thead><tr><th className={styles.th}>メーカー一覧</th></tr></thead>
                <tbody>
                    {manufactures && manufactures.map((item, index) => (<tr key={index} className={styles.tr}><td className={styles.td}>{item}</td><td><Button key={"delete" + index} onClick={() => handleDelete(index)} style={{ fontSize: 16, margin: 5 }}>削除</Button></td></tr>))}
                </tbody>
            </table>
        </div>
    )
}